module.exports = __webpack_public_path__ + "07_bob_grey.98db8056.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_bob_grey.png
// module id = Wxlf
// module chunks = 0